import { Injectable, EventEmitter } from '@angular/core';
import { RequestMethodsService } from '../commons/request_methods';
import { Constants } from '../commons/constants';
import { PointClick } from '../models/point-click.model'; 

@Injectable()
export class PointService {
    public pointClicked: PointClick = {x: 1, y: 1};
    public showModal: boolean = false;
    public pointModalEventEmitter = new EventEmitter();
    constructor(
        private requestMethodService: RequestMethodsService,
        private constants: Constants
    ) {
    }

    set(show: boolean) {
        this.showModal = show;
        this.pointModalEventEmitter.emit(show);
    }
   
     get() {
         return this.showModal;
     }  

    getPointsCategoryName(token, assetId){
        return this.requestMethodService.get(
            token,
            this.constants.BASE_URL,
            this.constants.GET_POINTS_CATEGORY_NAME,
            {
                id: assetId
            }
        );
    }

    setPointClicked(x: any, y: any,){
        this.pointClicked.y = parseFloat(y);
        let d = new Date(x);
        this.pointClicked.x = d.toLocaleTimeString('en-US', { hour12: false });
        this.pointClicked.x = (d.getMonth() + 1) + "/" + d.getDate() + "/" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    }

    getPointClicked(){
        return this.pointClicked;
    }

    
}



// WEBPACK FOOTER //
// ./src/services/point.service.ts